"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.__clearPendingRequests__ = exports.postAggregation = exports.getObjectUrl = exports.getCompiledResults = exports.getObjectWithUrl = exports.getReportResource = exports.getStatus = exports.deleteJob = exports.getContinueUri = void 0;
const tslib_1 = require("tslib");
const merge_1 = tslib_1.__importDefault(require("lodash/merge"));
function getContinueUri(continueUri, requestConfig) {
    return window[Symbol.for('AggConnectSetup')].http.get(continueUri, requestConfig);
}
exports.getContinueUri = getContinueUri;
function deleteJob(jobId) {
    if (!jobId)
        return;
    return window[Symbol.for('AggConnectSetup')].http.delete(`/api/aggregation/s/_SID_/${jobId}`);
}
exports.deleteJob = deleteJob;
function getStatus(jobId) {
    return window[Symbol.for('AggConnectSetup')].http.get(`/api/aggregation/s/_SID_/${jobId}/status`);
}
exports.getStatus = getStatus;
function getReportResource(reportId, reportType = '') {
    if (reportType === 'Workflow') {
        return window[Symbol.for('AggConnectSetup')].http.get(`/api/s/_SID_/workflow/${reportId}`);
    }
    return window[Symbol.for('AggConnectSetup')].http.get(`/api/s/_SID_/report/${reportId}`);
}
exports.getReportResource = getReportResource;
function getObjectWithUrl(url, requestConfig) {
    return window[Symbol.for('AggConnectSetup')].http.get(url, (0, merge_1.default)({
        headers: {},
        withCredentials: false
    }, requestConfig));
}
exports.getObjectWithUrl = getObjectWithUrl;
function getCompiledResults(id) {
    return window[Symbol.for('AggConnectSetup')].http.get(`/api/s/_SID_/workflow/${id}/results`);
}
exports.getCompiledResults = getCompiledResults;
function getObjectUrl(objectName) {
    return window[Symbol.for('AggConnectSetup')].http.get(`/api/s/_SID_/object/${objectName}/url`);
}
exports.getObjectUrl = getObjectUrl;
function postAggregation(request, requestConfig) {
    return window[Symbol.for('AggConnectSetup')].http.post('/api/aggregation/s/_SID_/', request, requestConfig);
}
exports.postAggregation = postAggregation;
function __clearPendingRequests__(config) {
    config.batch.length = 0;
    Object.keys(config.pendingRequests).forEach((requestId) => {
        delete config.pendingRequests[requestId];
    });
}
exports.__clearPendingRequests__ = __clearPendingRequests__;
